/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { FullAssignment, Nullable } from "../../utils/Interfaces";
import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TechnicianDashboardTabPanel, { technicianDashboarda11yProps } from "./TechnicianDashboardTabPanel";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import TechnicianAssignmentCard from "./TechnicianAssignmentCard";
import { NavigateFunction, useNavigate, useSearchParams } from "react-router-dom";

export interface TechnicianAssignmentCardListProps {
    assignments: FullAssignment[];
}

const TechnicianAssignmentCardList = (props: TechnicianAssignmentCardListProps) => {
    const { assignments } = props;

    const [allowTicketSelect, setAllowTicketSelect] = useState<boolean>(true);

    const [searchParams] = useSearchParams();
    const status: Nullable<string> = searchParams.get("status");

    const navigate: NavigateFunction = useNavigate();

    function statusToTabIndex(status: Nullable<string>): number {
        switch (status) {
            case "IP":
                return 0;
            case "SB":
                return 1;
            default:
                return 0;
        }
    }

    function tabIndexToStatus(index: number): string {
        switch (index) {
            case 0:
                return "IP";
            case 1:
                return "SB";
            default:
                return "IP";
        }
    }

    return (
        <>
            <Tabs
                value={statusToTabIndex(status)}
                sx={{ padding: "0px" }}
                onChange={(event, newValue) => navigate(`/tech-dash?status=${tabIndexToStatus(newValue)}`)}
                centered
            >
                <Tab label="In Progress" {...technicianDashboarda11yProps(0)} />
                <Tab label="Submitted" {...technicianDashboarda11yProps(1)} />
            </Tabs>

            <TechnicianDashboardTabPanel value={statusToTabIndex(status)} index={0} noSidePadding={true}>
                <Box>
                    {assignments.length === 0 && (
                        <Typography variant="h6" align="center" marginBottom={1}>
                            You have no in-progress assignments.
                        </Typography>
                    )}

                    {assignments
                        .filter((assignment: FullAssignment) => {
                            return !assignment.technician_entry.submitted;
                        })
                        .map((assignment: FullAssignment, key: number) => {
                            return (
                                <TechnicianAssignmentCard
                                    assignment={assignment}
                                    key={key}
                                    allowTicketSelect={allowTicketSelect}
                                    disableTicketSelect={() => setAllowTicketSelect(false)}
                                    enableTicketSelect={() => setAllowTicketSelect(true)}
                                />
                            );
                        })}
                </Box>
            </TechnicianDashboardTabPanel>

            <TechnicianDashboardTabPanel value={statusToTabIndex(status)} index={1} noSidePadding={true}>
                <Box>
                    {assignments.length === 0 && (
                        <Typography variant="h6" align="center" marginBottom={1}>
                            You have no submitted assignments.
                        </Typography>
                    )}

                    {assignments
                        .filter((assignment: FullAssignment) => {
                            return assignment.technician_entry.submitted;
                        })
                        .map((assignment: FullAssignment, key: number) => {
                            return (
                                <TechnicianAssignmentCard
                                    assignment={assignment}
                                    key={key}
                                    allowTicketSelect={allowTicketSelect}
                                    disableTicketSelect={() => setAllowTicketSelect(false)}
                                    enableTicketSelect={() => setAllowTicketSelect(true)}
                                />
                            );
                        })}
                </Box>
            </TechnicianDashboardTabPanel>
        </>
    );
};

export default TechnicianAssignmentCardList;
